<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="运营商" :label-width="55">
				<Select filterable clearable style="width: 120px;" v-model="formInline.OperatorId">
					<Option v-bind:key="item.Id" v-for="(item) in OperatorList" :value="item.Id">{{item.Name}}</Option>
					<!-- <span slot="prepend">联系电话</span> -->
				</Select>
			</FormItem>
			<FormItem prop="trackName" label="充电站" :label-width="55">
				<Select filterable placeholder="站点列表" style="width: 120px;" v-model="formInline.StationId">
					<Option :value="0">全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName" label="设备编号" :label-width="70">
				<Input type="text" style="width: 100px;" v-model="formInline.EquipmentNo" placeholder="设备编号" />
			</FormItem>
			<FormItem prop="trackName" label="设备序列号" :label-width="85">
				<div style="display: flex; flex-direction: row;">
					<Input type="text" style="width: 100px;" v-model="formInline.EquipmentSerialNo" placeholder="设备序列号" />
					<Input type="text" style="width: 100px;" v-model="formInline.EquipmentSerialNoEnd" placeholder="范围设备序列号" />
				</div>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" icon="ios-cloud-upload-outline" @click="handleMigration"
					v-if="hasWidgets('migration')">批量迁移</Button>
			</FormItem>
			<FormItem>
				<Upload :headers="upHeader" name="UpFile" :show-upload-list="false" :on-error="handleError"
					:on-format-error="handleFormatError" :on-success="handleSuccess" :format="['xlsx']"
					:before-upload="beforeUpload" :data='formInline' :action="importDataToEquipmentUrl"
					v-if="hasWidgets('import')">
					<Button icon="ios-cloud-upload-outline">批量导入</Button>
				</Upload>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="show('add')" v-if="hasWidgets('add')">新建设备</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">批量导入</Button> -->
			</div>
		</Form>
		<!-- <Table ref="equipTable" :columns="columns1" :data="data1" :height="tableHeight" size="small">
			<MyPage slot="footer" ref="sonPage" :param="pageParam" :url="getEquipmentInfoUrl" @listData='getDeviceData'>
			</MyPage>
		</Table> -->
		<PageTable ref="equipTable" :columns="columns1" :tableHeight="tableHeight" :url="getEquipmentInfoUrl" :queryParam="pageParam"></PageTable>
		<Modal v-model="modalView" :title="modal.Title" width="40%" :mask-closable="false" :closable="false">
			<!--设备安装和设备修改-->
			<Form label-position="right" :rules="ruleInline"
				v-if="modal.type=='add'||modal.type=='update'||modal.type=='view'" ref="FormItem" :model="FormItem"
				:label-width="120">
				<FormItem label="设备编号" prop="EquipmentNo">
					<Input :disabled="!ifAddEquipment" v-model="FormItem.EquipmentNo" @on-blur="equipNoChanged" placeholder="输入设备编号"></Input>
				</FormItem>
				<FormItem label="设备名称" prop="EquipmentName" v-show="false">
					<Input :disabled="ifViewStation" v-model="FormItem.EquipmentName" placeholder="输入设备名称"></Input>
				</FormItem>
				<FormItem label="设备类型" prop="EquipmentType">
					<Select :disabled="ifViewStation" placeholder="输入设备类型" v-model="FormItem.EquipmentType">
						<Option :value="1">直流设备</Option>
						<Option :value="2">交流设备</Option>
						<Option :value="3">交直流一体设备</Option>
						<Option :value="4">无线设备</Option>
						<Option :value="5">其他</Option>
					</Select>
				</FormItem>
				<FormItem label="设备型号" prop="EquipmentModel">
					<Select :disabled="ifViewStation" @on-change="modelDefine" placeholder="选择预设模板"
						v-model="FormItem.EquipmentModel">
						<Option v-bind:key="item.ModelId" v-for="(item) in EquipmentModelDefine" :value="item.ModelId">{{item.ModelDesc}}</Option>
					</Select>
				</FormItem>
				<FormItem label="设备序列号" prop="EquipmentSerialNo">
					<div style="display: flex; flex-direction: row;">
						<Input :disabled="!ifAddEquipment" v-model="FormItem.EquipmentSerialNo" placeholder="输入设备设备序列号"></Input>
						<Input style="width: 280px; margin-left: 5px;" :disabled="!ifAddEquipment" v-model="FormItem.EquipNum" placeholder="指定批量数量">
							<span slot="prepend">批量数量:</span>
						</Input>
					</div>
				</FormItem>
				<FormItem label="机器码1" prop="MachineCode1">
					<Input :disabled="!ifAddEquipment" v-model="FormItem.MachineCode1" placeholder="输入机器码1"></Input>
				</FormItem>
				<FormItem label="机器码2" prop="MachineCode2">
					<Input :disabled="!ifAddEquipment" v-model="FormItem.MachineCode2" placeholder="输入机器码2"></Input>
				</FormItem>
				<FormItem label="总功率" prop="TotolPower" v-show="false">
					<Input :disabled="ifViewStation" v-model="FormItem.TotolPower" placeholder="输入总功率"></Input>
				</FormItem>
				<FormItem label="额定功率" prop="EquipmentPower" v-show="false">
					<Input :disabled="ifViewStation" v-model="FormItem.EquipmentPower" placeholder="输入额定功率"></Input>
				</FormItem>
				<FormItem label="所属场站" prop="StationId">
					<Select filterable :disabled="ifViewStation" placeholder="所属场站" v-model="FormItem.StationId">
						<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
					</Select>
				</FormItem>
			</Form>
			<Button type="primary" v-if="modal.type=='add'" @click="addConnector" size="small" shape="circle"
				icon="md-add">添加</Button>
			<Button type="primary" v-if="modal.type=='add'" @click="delConnector" size="small" shape="circle"
				icon="ios-trash">删除</Button>
			<Table @on-selection-change="ConnectorsSelect" :columns="columns2" :data="FormItem.Connectors" size="small">
			</Table>
			<div v-if="modal.type!='addExcel'" slot="footer">
				<Button type="warning" size="large" @click="modalCancel">取消</Button>
				<Button v-if="modal.type=='add' || modal.type=='update'" type="success" size="large"
					@click="modalOk(modal.type)">确定</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	// import Qs from 'qs'
	import expandRow from './EquipmentManagementExpand.vue';
	// import gaodeMap from '../../../js/GaodeMapMethod.js'
	import PageTable from '../../public/PageTable/PageTable.vue';
	import {
		mapState,
		// mapGetters,
		// mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		components: {
			PageTable
		},
		data() {
			const validateConnertorsNum = (rule, value, callback) => {
				if (value.length == 0) {
					callback(new Error('请添加枪之后保存'));
				} else {
					callback();
				}
			};
			return {
				importDataToEquipmentUrl: webapi.base_api_url + '/Archives/ImportDataToEquipment',
				getEquipmentInfoUrl: webapi.base_api_url + '/Archives/GetEquipmentCarInfo',
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "",
				tableHeight: "650",
				modal: {
					Title: "信息添加",
					type: "add"
				},
				modalView: false,
				//地图modal
				showMap: false,
				center: [114.198595, 22.633595],
				zindex: 1100,
				//是否新增操作
				ifAddEquipment: true,
				// 是否修改操作
				ifUpdateEquip: false,
				//信息是否只能查看
				ifViewStation: false,
				//添加电枪的demo
				connectorDemo: {
					ConnectorTypeDesc: "",
					BmsPowerTypeDesc: "",
					PriceInfo: {
						Id: 0,
						Name: "",
						Period1BeginTime: "00:00",
						Period1EndTime: "00:00",
						Period1Price: 0,
						Period1ServicePrice: 0,
						Period2BeginTime: "00:00",
						Period2EndTime: "00:00",
						Period2Price: 0,
						Period2ServicePrice: 0,
						Period3BeginTime: "00:00",
						Period3EndTime: "00:00",
						Period3Price: 0,
						Period3ServicePrice: 0,
						Period4BeginTime: "00:00",
						Period4EndTime: "00:00",
						Period4Price: 0,
						Period4ServicePrice: 0,
						Period5BeginTime: "00:00",
						Period5EndTime: "00:00",
						Period5Price: 0,
						Period5ServicePrice: 0,
						Period6BeginTime: "00:00",
						Period6EndTime: "00:00",
						Period6Price: 0,
						Period6ServicePrice: 0,
						Period7BeginTime: "00:00",
						Period7EndTime: "00:00",
						Period7Price: 0,
						Period7ServicePrice: 0,
						Period8BeginTime: "00:00",
						Period8EndTime: "00:00",
						Period8Price: 0,
						Period8ServicePrice: 0,
						Period9BeginTime: "00:00",
						Period9EndTime: "00:00",
						Period9Price: 0,
						Period9ServicePrice: 0,
						Period10BeginTime: "00:00",
						Period10EndTime: "00:00",
						Period10Price: 0,
						Period10ServicePrice: 0,
						Period11BeginTime: "00:00",
						Period11EndTime: "00:00",
						Period11Price: 0,
						Period11ServicePrice: 0,
						Period12BeginTime: "00:00",
						Period12EndTime: "00:00",
						Period12Price: 0,
						Period12ServicePrice: 0,
						ServicePrice: 0,
						ModifyTime: "",
						ModifyBy: 0,
						PriceType: 0,
						Previous: 0
					},
					ConnectorNo: "",
					ConnectorName: "",
					ConnectorType: 3,
					Remarks: "",
					VoltageLowerLimits: 0,
					VoltageUpperLimits: 0,
					Power: 0,
					Voltage: 0,
					Current: 0,
					BmsPowerType: 1,
					PriceId: 1,
					Index: 0,
					EquipmentNo: "",
					ParkNo: ""
				},
				//电枪编号预设
				ConnectorNoDemo: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R",
					"S", "T", "U", "V", "W", "X", "Y", "Z"
				],
				//要删除的充电枪
				ConnectorCache: [],
				//档案-场站管理全部信息
				FormItem: {
					Id: 0,
					Connectors: [],
					EquipmentTypeDesc: "",
					EquipmentStatusDesc: "",
					NationalStandardDesc: "",
					StationName: "",
					Creator: "",
					Modifier: "",
					EquipmentNo: "",
					EquipmentName: "",
					MasterEquipment: "",
					EquipmentType: 1,
					EquipmentModel: "",
					ManufacturerId: "",
					ManufacturerName: "",
					ProductionDate: "",
					ProductionBatch: "",
					SoftVersion: "",
					HardVersion: "",
					EquipmentLng: 0,
					EquipmentLat: 0,
					TotolPower: 0,
					EquipmentPower: 0,
					EquipmentStatus: 1,
					NationalStandard: 2,
					AdapteCar: "",
					StationId: '',
					HeartbeatPeriod: 0,
					//添加又给弄没了
					CreatedTime: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					CreateBy: 0,
					ModifyTime: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					ModifyBy: 0,
					BarCode: "",
					QrCode: "",
					Ip: "",
					MinOutputCurrent: 0.000000,
					MaxOutputCurrent: 0.000000,
					MinOutputVoltage: 0.000000,
					MaxOutputVoltage: 0.000000,
					SoftName: "",
					Protocol: "",
					ProtocolVersion: "",
					Index: 0,
					IsEdit: false
				},
				//校验字段
				ruleInline: {
					Connectors: [{
						validator: validateConnertorsNum,
						trigger: 'blur',
					}],
					// EquipmentNo: [{
					// 	required: true,
					// 	message: '设备编号',
					// 	trigger: 'blur'
					// }],
					// EquipmentName: [{
					// 	required: true,
					// 	message: '设备名称',
					// 	trigger: 'blur'
					// }],
					// EquipmentType: [{
					// 	required: true,
					// 	message: '设备类型',
					// 	trigger: 'blur',
					// 	type: 'number'
					// }],
					EquipmentSerialNo: [{
						required: true,
						message: '设备序列号',
						trigger: 'blur'
					}],
					StationId: [{
						required: true,
						message: '所属场站',
						trigger: 'change',
						type: 'number'
					}],
					EquipmentModel: [{
						required: true,
						message: '设备型号模板',
						trigger: 'change',
					}]
				},
				//当前选中的设备模板的信息
				selectModel: [],
				BreadcrumbList: ['档案管理', '>>', '设备管理'],
				formInline: {
					OperatorId: '',
					StationId: 0,
					EquipmentNo: '',
					EquipmentSerialNo: '',
					EquipmentSerialNoEnd: '',
				},
				columns2: [{
						title: 'ID',
						key: 'Id',
						width: 90,
					},
					{
						title: '枪编号',
						key: 'ConnectorNo',
						minWidth: 100,
					},
					// {
					// 	title: '枪名称',
					// 	key: 'ConnectorName',
					// 	width: 100,
					// 	render: (h, params) => {
					// 		// 	if (this.ifViewStation) {
					// 		// 		return h('div', params.row.ConnectorName)
					// 		// 	}
					// 		// 	const _this = this
					// 		// 	return h('Input', {
					// 		// 		style: {
					// 		// 			width: '110px'
					// 		// 		},
					// 		// 		props: {
					// 		// 			//clearable: true,
					// 		// 			type: 'text',
					// 		// 			value: params.row.ConnectorName
					// 		// 		},
					// 		// 		on: {
					// 		// 			'on-blur': event => {
					// 		// 				_this.FormItem.Connectors[params.index].ConnectorName = event
					// 		// 					.target.value;
					// 		// 			}
					// 		// 		}
					// 		// 	})
					// 		if (this.ifViewStation) {
					// 			return h('div', params.row[params.column.key])
					// 		}
					// 		return h('Input', this.tableCellEditor(this, params, 80))
					// 	}
					// },
					{
						title: '枪类型',
						key: 'ConnectorType',
						width: 150,
						render: (h, params) => {
							if (this.ifViewStation) {
								return h('div', params.row.ConnectorTypeDesc)
							}
							const _this = this
							return h('Select', {
								props: {
									value: params.row.ConnectorType,
									transfer: true
								},
								on: {
									'on-change': value => {
										_this.FormItem.Connectors[params.index].ConnectorType = value;
									}
								}
							}, [
								_this.ConnectorTypeList.map((item) => { // this.productTypeList下拉框里的data
									return h('Option', {
											props: {
												value: item.id,
											}
										},
										item.Status
									)
								})
							])
						}
					},
					// {
					// 	title: '最低输出电压',
					// 	key: 'VoltageLowerLimits',
					// 	render: (h, params) => {
					// 		if (this.ifViewStation) {
					// 			return h('div', params.row[params.column.key])
					// 		}
					// 		return h('Input', this.tableCellEditor(this, params, 45))
					// 	}
					// },
					// {
					// 	title: '最高输出电压',
					// 	key: 'VoltageUpperLimits',
					// 	render: (h, params) => {
					// 		if (this.ifViewStation) {
					// 			return h('div', params.row[params.column.key])
					// 		}
					// 		return h('Input', this.tableCellEditor(this, params, 45))
					// 	}
					// },
					// {
					// 	title: '额定功率',
					// 	key: 'Power',
					// 	render: (h, params) => {
					// 		if (this.ifViewStation) {
					// 			return h('div', params.row[params.column.key])
					// 		}
					// 		return h('Input', this.tableCellEditor(this, params, 45))
					// 	}
					// },
					// {
					// 	title: '额定电压',
					// 	key: 'Voltage',
					// 	render: (h, params) => {
					// 		if (this.ifViewStation) {
					// 			return h('div', params.row[params.column.key])
					// 		}
					// 		return h('Input', this.tableCellEditor(this, params, 45))
					// 	}
					// },
					// {
					// 	title: '额定电流',
					// 	key: 'Current',
					// 	render: (h, params) => {
					// 		if (this.ifViewStation) {
					// 			return h('div', params.row[params.column.key])
					// 		}
					// 		return h('Input', this.tableCellEditor(this, params, 45))
					// 	}
					// },
					// {
					// 	title: '辅源类型',
					// 	key: 'BmsPowerType',
					// 	width: 110,
					// 	render: (h, params) => {
					// 		if (this.ifViewStation) {
					// 			return h('div', params.row.BmsPowerTypeDesc);
					// 		}
					// 		const _this = this;
					// 		return h('Select', {
					// 			props: {
					// 				value: params.row.BmsPowerType,
					// 				transfer: true
					// 			},
					// 			on: {
					// 				'on-change': value => {
					// 					_this.FormItem.Connectors[params.index].BmsPowerType = value;
					// 				}
					// 			}
					// 		}, [
					// 			_this.BmsPowerTypeList.map((item) => { // this.productTypeList下拉框里的data
					// 				return h('Option', {
					// 						props: {
					// 							value: item.id,
					// 						}
					// 					},
					// 					item.text
					// 				)
					// 			})
					// 		]);
					// 	}
					// },
					// // {
					// 	title: '价格id',
					// 	key: 'PriceId',
					// }, {
					// 	title: '顺序位',
					// 	key: 'Index',
					// }, {
					// 	title: '充电桩编码',
					// 	key: 'EquipmentNo',
					// }, 
					// {
					// 	title: '车位号',
					// 	key: 'ParkNo',
					// 	render: (h, params) => {
					// 		console.log('params: ', params, params.row[params.column.key])
					// 		const _this = this
					// 		if (this.ifViewStation) {
					// 			return h('div', params.row[params.column.key])
					// 		}
					// 		return h('Input', this.tableCellEditor(this, params, 45))
					// 		// return h('Input', {
					// 		// 	style: {
					// 		// 		width: '50px'
					// 		// 	},
					// 		// 	props: {
					// 		// 		clearable: true,
					// 		// 		type: 'text',
					// 		// 		value: params.row.ParkNo
					// 		// 	},
					// 		// 	on: {
					// 		// 		'on-blur': event => {
					// 		// 			_this.FormItem.Connectors[params.index].ParkNo = event.target
					// 		// 				.value;
					// 		// 		}
					// 		// 	}
					// 		// })
					// 	}
					// },
					// {
					// 	title: '备注',
					// 	key: 'Remarks',
					// 	render: (h, params) => {
					// 		if (this.ifViewStation) {
					// 			return h('div', params.row.Remarks)
					// 		}
					// 		const _this = this
					// 		return h('Input', {
					// 			style: {
					// 				width: '50px'
					// 			},
					// 			props: {
					// 				clearable: true,
					// 				type: 'text',
					// 				value: params.row.Remarks
					// 			},
					// 			on: {
					// 				'on-blur': event => {
					// 					_this.FormItem.Connectors[params.index].Remarks = event.target
					// 						.value;
					// 				}
					// 			}
					// 		})
					// 	}
					// },
				],
				//table标题数据
				columns1: [{
						type: 'selection',
						width: 35,
					},
					{
						type: 'expand',
						width: 50,
						render: (h, params) => {
							return h(expandRow, {
								props: {
									row: params.row
								}
							})
						}
					},
					{
						title: 'ID',
						key: 'Id',
						width: 90,
					},
					{
						title: '设备编号',
						key: 'EquipmentNo',
						width: 140,
					}, {
						title: '设备序列号',
						key: 'EquipmentSerialNo',
						width: 120,
					}, {
						title: '机器码1',
						key: 'MachineCode1',
						minWidth: 125,
					}, {
						title: '机器码2',
						key: 'MachineCode2',
						minWidth: 125,
					},
					// {
					// 	title: '设备名称',
					// 	key: 'EquipmentName',
					// 	width: 100,
					// }, {
					// 	title: '所属主设备编号',
					// 	key: 'MasterEquipment',
					// 	width: 100,
					// },
					{
						title: '设备类型',
						key: 'EquipmentType',
						width: 100,
						render: (h, params) => {
							return h('div', params.row.EquipmentTypeDesc)
						}
					},
					{
						title: '枪口数量',
						key: 'CreateBy',
						render: (h, params) => {
							return h('div', params.row.Connectors.length)
						},
						width: 100,
					},
					{
						title: '设备型号',
						key: 'EquipmentModel',
						width: 120
					},
					// {
					// 	title: '设备生产商名称',
					// 	key: 'ManufacturerName',
					// 	width: 200
					// },
					// {
					// 	title: '额定功率',
					// 	key: 'EquipmentPower',
					// 	width: 100
					// },
					{
						title: '所属场站',
						key: 'StationId',
						minWidth: 200,
						render: (h, params) => {
							return h('div', params.row.StationName)
						}
					},
					{
						title: '设备状态',
						key: 'EquipmentStatusDesc',
						width: 100,
					},
					{
						title: '建档时间',
						key: 'CreateTime',
						width: 150,
					},
					{
						title: '操作',
						key: 'action',
						minWidth: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("update", params.row)
										}
									}
								}, '修改') : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("view", params.row)
										}
									}
								}, '查看') : h(),
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h(
									'Dropdown', {
										on: {
											//为了不误操作，确定取消相反
											'on-click': (name) => {
												this.$Modal.confirm({
													title: name,
													okText: '取消',
													cancelText: '确定',
													onCancel: () => {
														this.otherMethod(name, params.row
															.EquipmentNo);
													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, '其他操作'),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name))
											.map((
												item) => { // this.productTypeList下拉框里的data
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h()
							]);
						}
					}
				],
				data1: [],
				methodList: [{
						id: 1,
						name: 'building',
						Status: '建设中'
					}, {
						id: 5,
						name: 'swithcOff',
						Status: '关闭下线'
					},
					{
						id: 6,
						name: 'maintaining',
						Status: '维护中'
					},
					{
						id: 50,
						name: 'running',
						Status: '正常使用'
					}
				],
				ConnectorTypeList: [{
						id: 1,
						Status: '家用插座（模式2）'
					}, {
						id: 2,
						Status: '交流接口插座（模式3，连接方式B ）'
					},
					{
						id: 3,
						Status: '交流接口插头（带枪线，模式3，连接方式C）'
					},
					{
						id: 4,
						Status: '直流接口插头（带枪线，模式4）'
					}, {
						id: 5,
						Status: '大功率交流接口插头'
					}, {
						id: 100,
						Status: '其他'
					}
				],
				BmsPowerTypeList: [{
					id: 1,
					text: '12V',
				}, {
					id: 2,
					text: '24V',
				}, {
					id: 3,
					text: '自适应'
				}, {
					id: 255,
					text: '其他',
				}],
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 160;
			_this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			const operateColumnWidth = Math.max(60, (36 + (this.hasWidgets('edit') ? 60 : 0) + (this.hasWidgets('view') ?
					60 : 0) +
				(this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? 80 : 0)));
			this.columns1.at(-1).minWidth = operateColumnWidth;
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations',
				EquipmentModelDefine: 'EquipmentModelDefine',
				OperatorList: 'typeList',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//设备添加预设值
			modelDefine: function(modelValue) {
				const _this = this
				// console.log("1111111111111")
				if (modelValue != undefined) {
					// console.log("2222222222222")
					_this.selectModel = _this.EquipmentModelDefine.filter(function(model) {
						return model.ModelId == modelValue
					});
					for (let var1 in _this.FormItem) {
						if (_this.selectModel[0].Equipment[var1] != undefined) {
							_this.FormItem[var1] = _this.selectModel[0].Equipment[var1]
						}
					}
					if (_this.FormItem.EquipmentNo != '') {
						const _this = this
						_this.FormItem.Connectors = [];
						for (let i = 0; i < _this.selectModel[0].ConnectorNum; i++) {
							_this.addConnector()
						}
					}
				}
			},
			equipNoChanged: function() {
				const _this = this
				if (!_this.FormItem.EquipmentModel) return;
				
				_this.FormItem.Connectors = [];
				for (let i = 0; i < _this.selectModel[0].ConnectorNum; i++) {
					_this.addConnector()
				}
			},
			//点击自动添加电枪
			addConnector: function() {
				const _this = this
				if (_this.FormItem.EquipmentNo == "") {
					_this.$Message.warning('请填写设备编号');
				} else if (_this.selectModel.length == 0) {
					_this.$Message.warning('请选择设备型号模板');
				} else {
					for (let var1 in _this.connectorDemo) {
						console.log(var1)
						// let item = "Connector" + var1;
						let item = var1;
						console.log(_this.selectModel[0].Connector[item])
						if (_this.selectModel[0].Connector[item] != undefined) {
							_this.connectorDemo[var1] = _this.selectModel[0].Connector[item]
							// _this.connectorDemo[var1].ConnectorType = _this.FormItem.EquipmentType == 2 ? 3 : 4;
						}
					}
					_this.connectorDemo.ConnectorNo = _this.FormItem.EquipmentNo + _this.ConnectorNoDemo[_this.FormItem
						.Connectors.length];
					// _this.connectorDemo.ConnectorType = _this.FormItem.ConnectorType;
					// _this.FormItem.Connectors.forEach(function(item, index) {
					// 	if (item.ConnectorNo == _this.connectorDemo.ConnectorNo) {
					// 		_this.connectorDemo.ConnectorNo = _this.connectorDemo.ConnectorNo + '1'
					// 	}
					// })
					_this.FormItem.Connectors.push({
						..._this.connectorDemo
					})
				}
			},
			//选中的枪加入缓存
			ConnectorsSelect: function(Connectors) {
				this.ConnectorCache = Connectors
			},
			//删除选中电枪
			delConnector: function() {
				const _this = this
				_this.FormItem.Connectors.pop();
				// if (_this.ConnectorCache.length == 0) {
				// 	this.$Message.info('请选择要删除的枪');
				// } else {
				// 	_this.FormItem.Connectors = _this.FormItem.Connectors.filter(function(item, index, arr) {
				// 		let flag = true;
				// 		_this.ConnectorCache.forEach(function(item2, index) {

				// 				if (item2.ConnectorNo == item.ConnectorNo) {

				// 					flag = false
				// 				} else {

				// 					flag = true
				// 				}
				// 			}

				// 		)

				// 		return flag
				// 	})
				// 	_this.ConnectorCache = []
				// }
			},
			//删除修改之外的其他操作
			otherMethod: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item) {
					return item.Status == name
				})[0]).id
				// console.log(typeNum)
				this.$axios.post(webapi.base_api_url + "/Archives/SetEquipmentStatus", {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.info(name + '成功');
						// this.$refs.sonPage.getList();
						this.$refs.equipTable.getData();
					}
				})
			},

			//操作
			show: function(type, rowInfo) {
				this.ifAddEquipment = false;
				this.ifViewStation = false;
				this.ifUpdateEquip = true;
				switch (type) {
					case "add":
						this.modal.type = "add";
						this.modal.Title = "信息添加";
						this.ifAddEquipment = true
						this.$refs.FormItem.resetFields();
						this.selectModel = []
						this.FormItem = {
							Connectors: [],
							EquipmentTypeDesc: "",
							EquipmentStatusDesc: "",
							NationalStandardDesc: "",
							StationName: "",
							Creator: "",
							Modifier: "",
							EquipmentNo: "",
							EquipmentName: "",
							MasterEquipment: "",
							EquipmentType: 1,
							EquipmentModel: "",
							ManufacturerId: "",
							ManufacturerName: "",
							ProductionDate: "",
							ProductionBatch: "",
							SoftVersion: "",
							HardVersion: "",
							EquipmentLng: 0,
							EquipmentLat: 0,
							TotolPower: 0,
							EquipmentPower: 0,
							EquipmentStatus: 50,
							NationalStandard: 2,
							AdapteCar: "",
							StationId: '',
							HeartbeatPeriod: 0,
							//添加又给弄没了
							CreatedTime: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
							CreateBy: 0,
							ModifyTime: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
							ModifyBy: 0,
							BarCode: "",
							QrCode: "",
							Ip: "",
							MinOutputCurrent: 0.000000,
							MaxOutputCurrent: 0.000000,
							MinOutputVoltage: 0.000000,
							MaxOutputVoltage: 0.000000,
							SoftName: "",
							Protocol: "",
							ProtocolVersion: "",
							Index: 0,
							IsEdit: false
						}
						break;
					case "update":
						this.modal.type = "update";
						this.modal.Title = "信息修改";
						this.getUpdateMessage(rowInfo);
						this.ifUpdateEquip = true;
						//this.ifViewStation=false
						break;
					case "view":
						this.modal.type = "view";
						this.modal.Title = "信息查看";
						this.getUpdateMessage(rowInfo);
						this.ifViewStation = true
						break;
				}
				this.modalView = true;
			},
			tableCellEditor(_this, params, width) {
				return {
					style: {
						width: width + 'px'
					},
					props: {
						clearable: false,
						type: 'text',
						value: params.row[params.column.key]
					},
					on: {
						'on-blur': event => {
							// params.row[params.column.key] = event.target.value
							_this.FormItem.Connectors[params.index][params.column.key] = event.target.value
						}
					}
				}
			},
			getDeviceData: function(data) {
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				// this.$refs.sonPage.getList();
				this.$refs.equipTable.getData();
			},
			handleMigration: function() {
				const _this = this;
				let selections = _this.$refs.equipTable.getSelection();

			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160 - (window.innerWidth < 1258 ? 40 : 0);
			},
			modalCancel: function() {
				if (this.modal.type === "install") {
					//this.$refs.InstallForm.resetFields();
				} else if (this.modal.type === "add" || this.modal.type === "update" || this.modal.type === "view") {
					this.$refs.FormItem.resetFields();
					this.FormItem.Connectors = [];
					this.modalView = false
				}
			},
			deepClone(params) {
				// 如果数组类型数据
				if (Array.isArray(params)) {
					let newnew = []
					for (let i = 0; i < params.length; i++) {
						newnew[i] = this.deepClone(params[i]) // 递归调用克隆
					}
					return newnew // 克隆完以后，再返回出结果
				}
				// 如果是对象类型数据
				if (Object.prototype.toString.call(params) === '[object Object]') {
					let newnew = {}
					for (const key in params) {
						newnew[key] = this.deepClone(params[key]) // 递归调用克隆
					}
					return newnew // 克隆完以后，再返回出结果
				}
				// 如果是普通数据类型
				return params
			},
			getUpdateMessage: function(equipInfo) {
				console.log(equipInfo);
				const _this = this;
				_this.FormItem = {};
				_this.FormItem = _this.deepClone(equipInfo);
				// for (let i = 0; i < _this.data1.length; i++) {
				// 	if (_this.data1[i].EquipmentNo == EquipmentNo) {
				// 		_this.FormItem = Object.assign({}, _this.data1[i])
				// 	}
				// }
				//_this.modelDefine(_this.FormItem.EquipmentModel)
			},
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case "add":
						_this.FormItem.Id = 0;
						_this.FormItem.IsEdit = false
						break;
					case "update":
						_this.FormItem.IsEdit = true
						break;
				}
				//没定必填项
				_this.$refs.FormItem.validate((valid) => {
					// console.log("设备" + type + "----" + valid)
					if (valid) {
						const param = _this.FormItem
						_this.$axios.post(webapi.base_api_url + '/Archives/AddEquipment',
							param
						).then(res => {
							// console.log(res)
							if (res.data.Code == 0) {
								_this.$Message.info("设备" + type + "成功");
								// _this.$refs.sonPage.getList();
								_this.$refs.equipTable.getData();
								this.modalView = false;
							} else {
								_this.$Message.info("设备" + type + "失败:" + res.data.Data);
							}
						})
					}
				})
			},
			// mapOpen: function() {
			// 	this.showMap = true;
			// 	gaodeMap.initMap("map", 10, this.center, 'normal');
			// 	gaodeMap.mapOn(this);
			// },
			// closeMap: function() {
			// 	gaodeMap.map.destroy();
			// 	gaodeMap.map = '';
			// 	this.showMap = false;
			// },
			beforeUpload(file) {
				const _this = this
				if (_this.formInline.StationId != 0) {
					let stationName = ''
					_this.StationList.forEach(function(item) {
						console.log(item);
						if (item.StationId == _this.formInline.StationId) {
							stationName = item.StationName
						}
					})
					let p = new Promise(function(resolve, reject) {
						_this.$Modal.confirm({
							title: "添加设备的场站-->" + stationName,
							okText: '取消',
							cancelText: '确定',
							onCancel: () => {
								resolve()
							},
							onOk: () => {
								reject()
							}
						});
					})
					return p
				} else {
					this.$Message.success("请在左侧选择具体场站！！！");
					return false
				}
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: '文件格式错误',
					desc: '文件' + file.name + '请上传xlsx格式文件'
				});
			},
			handleSuccess(res, file) {
				this.$Message.success("导入结果：" + res.Msg + "---" + res.Data);
				this.handleSubmit()
			},
			handleError(error, file) {
				this.$Message.error("导入错误");
			},
			handleMigration() {
				const _this = this;
				const selections = _this.$refs.equipTable.getSelection();
				// console.log(selections);
				if (selections.length < 1) {
					this.$Message.error("请选择要迁移的设备");
					return;
				}
				let stationId = 0;
				_this.$Modal.confirm({
					title: "选择场站",
					render: (h) => {
						return h('Select', {
							props: {
								filterable: true,
							},
							on: {
								'on-select': (v, a, b, c) => {
									stationId = v.value;
									console.log(v, a, b, c);
								}
							}
						}, _this.StationList.map(obj => {
							return h('Option', {
								props: {
									value: obj.StationId,
									label: obj.StationName
								}
							})
						}))
					},
					okText: '确定',
					onOk: () => {
						console.log(stationId);
						const param = {
							stationId: stationId,
							equipList: selections.map(obj => obj.Id)
						};
						_this.$axios.post(webapi.base_api_url + '/Archives/MigrationEquipment', param).then(res => {
							if (res.data.Code == 0 || res.data.Code == 200) {
								_this.$Message.error("迁移成功");
								_this.handleSubmit();
							} else {
								_this.$Message.error("迁移失败");
							}
						});
					}
				});
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}
</style>